var map = {
	"./de.svg": 4264,
	"./fr.svg": 1965,
	"./gb.svg": 9230,
	"./us.svg": 7433,
	"Images/Flags/de.svg": 4264,
	"Images/Flags/fr.svg": 1965,
	"Images/Flags/gb.svg": 9230,
	"Images/Flags/us.svg": 7433
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 642;